import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import AddEditSopModuleForm from "../../components/SopModule/AddEditSopModuleForm";
import {
  GetSingleSopDetailsPayloadType,
  GetUniqueCheckSopDetailsPayloadType,
  UpdateSopModulePayloadType,
} from "../../commonTypes/sopModuleTypes";
import {
  getSingleSopDetailsAction,
  getUniqueCheckSopFileNameAction,
  resetSingleSopDetails,
  resetSopModuleError,
  resetSopModuleMessage,
  resetSopModuleStatusCode,
  resetSopModuleSuccess,
  resetUniqueCheckFileNameMessage,
  updateSopModuleAction,
} from "../../redux/sopModule";
import { resetSession } from "../../redux/auth";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  sopModuleTotalCount: number;
  sopModuleList: any;
  fileManagerFetching: boolean;
  uniqueCheckFileNameFetching: boolean;
  uniqueCheckFileNameMessage: string;
  dispatchResetSession: () => void;
  dispatchResetSopModuleError: () => void;
  dispatchResetSopModuleSuccess: () => void;
  dispatchResetSopModuleStatusCode: () => void;
  dispatchResetSopModuleListing: () => void;
  dispatchResetSopModuleMessage: () => void;
  dispatchResetSingleSopDetails: () => void;
  dispatchResetUniqueCheckFileNameMessage: () => void;
  dispatchUpdateSopModule: (data: UpdateSopModulePayloadType) => void;
  dispatchGetUniqueCheckSopFileNameAction: (
    data: GetUniqueCheckSopDetailsPayloadType
  ) => void;
  dispatchGetSingleSopDetailsAction: (
    data: GetSingleSopDetailsPayloadType
  ) => void;
  singleSopDetails: any;
};
const EditSopModule = ({
  history,
  singleSopDetails,
  fileManagerFetching,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  sopModuleList,
  sopModuleTotalCount,
  uniqueCheckFileNameFetching,
  uniqueCheckFileNameMessage,
  dispatchResetSession,
  dispatchResetSopModuleError,
  dispatchResetSopModuleSuccess,
  dispatchResetSopModuleStatusCode,
  dispatchResetSopModuleMessage,
  dispatchUpdateSopModule,
  dispatchGetSingleSopDetailsAction,
  dispatchResetSingleSopDetails,
  dispatchResetUniqueCheckFileNameMessage,
  dispatchGetUniqueCheckSopFileNameAction,
}: AppProps) => {
  const clientCode = history?.location?.state?.client_code;
  const sopId = history?.location?.state?.sop_id;
  const company_name = history?.location?.state?.company_name;
  const type = history?.location?.state?.type

  useEffect(() => {
    dispatchResetSopModuleStatusCode();
    dispatchResetSopModuleMessage();
    dispatchResetSopModuleError();
    dispatchResetSingleSopDetails();
    dispatchResetUniqueCheckFileNameMessage();
  }, []);

  useEffect(() => {
    const finalData = {
      token,
      sopId,
      clientCode,
      type: type==="adminReport" ? "admin" : ""
    };
    if (clientCode && token) {
      dispatchGetSingleSopDetailsAction(finalData);
    }
  }, [sopId]);

  const handleUniqueCheckFileName = ({ fileName }: any) => {
    dispatchResetUniqueCheckFileNameMessage();
    const finalData = {
      token,
      sopId,
      clientCode,
      fileName,
      type: "update",
      role:type==="adminReport" ? "admin" : ""
    };
    dispatchGetUniqueCheckSopFileNameAction(finalData);
  };

  const handleSubmitData = (data: any) => {
    if (clientCode && token) {
      const finalData = {
        clientCode,
        token,
        sopId: singleSopDetails?.sop_id,
        ...data,
      };
      dispatchUpdateSopModule(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSopModuleError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`SOP Details Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetSopModuleSuccess();
            // dispatchResetDisbursementList();
            // dispatchResetSharedDisbursementList();
            history?.push({
              pathname: `/sops/${clientCode}`,
              state: { client_code: clientCode, company_name },
            });
          }}
          statusCode={statusCode}
        />
      );
    }
    return false;
  };
  return (
    <>
      <CommonHeader title={`Edit SOP Details`} />
      <ContentArea>
        <AddEditSopModuleForm
          token={token}
          type={type}
          history={history}
          isEdit={true}
          handleSubmitData={handleSubmitData}
          singleSopDetails={singleSopDetails}
          uniqueCheckFileNameFetching={uniqueCheckFileNameFetching}
          uniqueCheckFileNameMessage={uniqueCheckFileNameMessage}
          uniqueFileNameCheck={handleUniqueCheckFileName}
          clientCode={clientCode}
          fileManagerFetching={fileManagerFetching}
        />
      </ContentArea>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.sopModule.success,
  fetching: state.sopModule.fetching,
  message: state.sopModule.message,
  statusCode: state.sopModule.statusCode,
  error: state.sopModule.error,
  singleSopDetails: state.sopModule.singleSopDetails,
  uniqueCheckFileNameFetching: state.sopModule.uniqueCheckFileNameFetching,
  uniqueCheckFileNameMessage: state.sopModule.uniqueCheckFileNameMessage,
  fileManagerFetching: state.fileManager.fetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSopModuleSuccess: () => dispatch(resetSopModuleSuccess()),
  dispatchResetSopModuleError: () => dispatch(resetSopModuleError()),
  dispatchResetSopModuleMessage: () => dispatch(resetSopModuleMessage()),
  dispatchResetSopModuleStatusCode: () => dispatch(resetSopModuleStatusCode()),
  dispatchResetSingleSopDetails: () => dispatch(resetSingleSopDetails()),
  dispatchResetUniqueCheckFileNameMessage: () =>
    dispatch(resetUniqueCheckFileNameMessage()),
  dispatchUpdateSopModule: (data: UpdateSopModulePayloadType) =>
    dispatch(updateSopModuleAction(data)),
  dispatchGetSingleSopDetailsAction: (data: GetSingleSopDetailsPayloadType) =>
    dispatch(getSingleSopDetailsAction(data)),
  dispatchGetUniqueCheckSopFileNameAction: (
    data: GetUniqueCheckSopDetailsPayloadType
  ) => dispatch(getUniqueCheckSopFileNameAction(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditSopModule);
